// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"a790ee9e","453":"edee54cb","457":"62456c43"}[chunkId] + ".chunk.js";
};